import theme from 'utils/theme'

export const timerClasses = {
  timer: {
    marginTop: `${theme.spacing(0.5)} !important`,
    display: 'inline-flex',
    color: theme.palette.text.secondary,
  },
}
